import { render, staticRenderFns } from "./AvatarUpload.vue?vue&type=template&id=276e8848&scoped=true"
import script from "./AvatarUpload.vue?vue&type=script&lang=ts&setup=true"
export * from "./AvatarUpload.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AvatarUpload.vue?vue&type=style&index=0&id=276e8848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276e8848",
  null
  
)

export default component.exports